import { supabase } from '../lib/supabase';

export const careersService = {
	// Get all careers (for admin) or active only (for public)
	async getCareers(adminMode = false) {
		try {
			let query = supabase
				.from('careers')
				.select('*')
				.order('display_order', { ascending: true })
				.order('created_at', { ascending: false });

			// Only filter by active status if not in admin mode
			if (!adminMode) {
				query = query.eq('is_active', true);
			}

			const { data, error } = await query;

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error fetching careers:', error);
			return { data: null, error };
		}
	},

	// Get featured careers
	async getFeaturedCareers() {
		try {
			const { data, error } = await supabase
				.from('careers')
				.select('*')
				.eq('is_active', true)
				.eq('is_featured', true)
				.order('display_order', { ascending: true });

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error fetching featured careers:', error);
			return { data: null, error };
		}
	},

	// Get careers by department
	async getCareersByDepartment(department) {
		try {
			const { data, error } = await supabase
				.from('careers')
				.select('*')
				.eq('is_active', true)
				.eq('department', department)
				.order('display_order', { ascending: true });

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error fetching careers by department:', error);
			return { data: null, error };
		}
	},

	// Get a specific career by slug
	async getCareerBySlug(slug) {
		try {
			const { data, error } = await supabase
				.from('careers')
				.select('*')
				.eq('slug', slug)
				.eq('is_active', true)
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error fetching career by slug:', error);
			return { data: null, error };
		}
	},

	// Create a new career
	async createCareer(careerData) {
		try {
			const { data, error } = await supabase
				.from('careers')
				.insert([careerData])
				.select()
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error creating career:', error);
			return { data: null, error };
		}
	},

	// Update a career
	async updateCareer(id, updates) {
		try {
			const { data, error } = await supabase
				.from('careers')
				.update(updates)
				.eq('id', id)
				.select()
				.single();

			if (error) throw error;
			return { data, error: null };
		} catch (error) {
			console.error('Error updating career:', error);
			return { data: null, error };
		}
	},

	// Delete a career
	async deleteCareer(id) {
		try {
			const { error } = await supabase
				.from('careers')
				.delete()
				.eq('id', id);

			if (error) throw error;
			return { error: null };
		} catch (error) {
			console.error('Error deleting career:', error);
			return { error };
		}
	},

	// Generate slug from title
	generateSlug(title) {
		return title
			.toLowerCase()
			.replace(/[^a-z0-9 -]/g, '')
			.replace(/\s+/g, '-')
			.replace(/-+/g, '-')
			.trim('-');
	}
};
